import { connect } from 'react-redux';
import { BasicTray } from '../shared/components/Tray/BasicTray';
import { CallSelectors } from '../../../store/call/selectors';
import { IState } from '../../../store/types';
import { IBasicTrayEvents, IBasicTrayFields } from '../shared/components/Tray/types';
import { CallAppEffects } from './events';

const mapStateToProps = (
) => {
	return (
		state: IState
	): IBasicTrayFields => {
		return {
			isToken: !!CallSelectors.getToken(state),
			startedAt: CallSelectors.getStartedAt(state),
		}
	};
}

const mapDispatchToProps = (
	dispatch: any
): IBasicTrayEvents => {
	return {
		onLeave: () => dispatch(CallAppEffects.onLeave()),
		onOpen: () => dispatch(CallAppEffects.onOpen()),
	}
};

export const BasicTrayHOC = connect(
	mapStateToProps,
	mapDispatchToProps,
)(BasicTray);

BasicTrayHOC.displayName = 'BasicTrayHOC';
